import React from 'react'

function GrayText ({ children, className }) {
  return (
    <div className={'text-gray-400 text-sm ' + className}>
      {children}
    </div>
  )
}

export default GrayText
